module.exports = __webpack_public_path__ + "img/flower-top-big.22642664.png";